import React, { useState, useEffect, useContext } from 'react'
import classNames from 'classnames'

import ModalV2 from '../../tmoModal/ModalV2'
import withModal from '../../tmoModal/withModal'
import TmoButton from '../../tmoButtons/TmoButton'
import RawDataObject from '../../tmoRawDataObject/RawDataObject'
import ExportJSONDataAsFile from '../ExportJSONDataAsFile/ExportJSONDataAsFile'
import ModalContext from '../../context/ModalContext'
import TmoSvg from '../TmoSvg'

import { FaCode } from 'react-icons/fa'
import style from './RawData.module.css'

const RawData = ({
  className,
  rawObject,
  openModal,
  type,
  title,
  usePortal,
  modalType,
  buttonType,
  text,
  tooltip,
  tooltipPosition = 'bottom',
  hideIcon = false,
  testId
}) => {
  const { closeModal } = useContext(ModalContext)
  const [copyState, setCopyState] = useState(false)
  const copyToClickBoard = () => {
    navigator.clipboard.writeText(JSON.stringify(rawObject, null, 2))
    setCopyState(true)
  }
  useEffect(() => {
    copyState &&
      setTimeout(async () => {
        setCopyState(false)
      }, 2000)
  }, [copyState, setCopyState])
  return (
    <div className={classNames(style.container, className)}>
      <TmoButton
        className={classNames(
          style.button,
          modalType === 'slide' && style.slide_button,
          modalType === 'slide' && type === ' ' && style.icon_button
        )}
        type={buttonType ? buttonType : 'secondary'}
        onClick={openModal}
        tooltip={tooltip}
        position={tooltipPosition}
        data-testid={testId}
        aria-label={tooltip}
      >
        {!hideIcon && <FaCode className={style.icon} />}
        <div className={style.button_text}>
          {' '}
          {type ? type : 'Full'}
          {type === ' ' ? ' ' : ' Object'}
          {text && text}{' '}
        </div>
      </TmoButton>
      <ModalV2
        title={title}
        isRawObjectModal
        portal={usePortal}
        modalType={modalType}
      >
        {modalType && modalType === 'slide' ? (
          <div className={style.content}>
            <div
              className={style.scrollable_content}
              role='region'
              tabIndex={0}
            >
              <RawDataObject rawObject={rawObject} />
            </div>
            <div className={style.footer_wrapper}>
              <TmoButton
                onClick={closeModal}
                icon={
                  <TmoSvg
                    className={style.button_icon}
                    svgId='icon-close-modal'
                  />
                }
                type='magenta_secondary'
                position='top'
                aira-label='Cancel'
              >
                Cancel
              </TmoButton>
              <div className={style.button_wrapper}>
                <TmoButton
                  icon={
                    <TmoSvg className={style.button_icon} svgId='icon-copy' />
                  }
                  onClick={copyToClickBoard}
                  type='magenta_primary'
                  position='top'
                  aria-label='Copy to Clipboard'
                >
                  {copyState ? 'Copied' : 'Copy'}
                </TmoButton>
                <ExportJSONDataAsFile
                  buttonType={'magenta_primary'}
                  buttonText='Export'
                  data={rawObject}
                  fileName={title}
                  fileExtension='json'
                  tooltipPosition='top'
                />
              </div>
              <div aria-live='polite' className={style.hide_text}>
                {copyState && 'Data copied to clipboard'}
              </div>
            </div>
          </div>
        ) : (
          <React.Fragment>
            <ExportJSONDataAsFile
              buttonText='Export'
              data={rawObject}
              fileName={title}
              fileExtension='json'
            />
            <RawDataObject rawObject={rawObject} />
          </React.Fragment>
        )}
      </ModalV2>
    </div>
  )
}

export default withModal(RawData)
